//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'IconButton',
  props: {
    plain: { type: Boolean, default: false }
  }
}
